import { render, staticRenderFns } from "./GapStatusBadge.vue?vue&type=template&id=23bba886&scoped=true&"
import script from "./GapStatusBadge.vue?vue&type=script&lang=js&"
export * from "./GapStatusBadge.vue?vue&type=script&lang=js&"
import style0 from "./GapStatusBadge.vue?vue&type=style&index=0&id=23bba886&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bba886",
  null
  
)

export default component.exports